import { render, staticRenderFns } from "./sendClientWhats.vue?vue&type=template&id=ffbc4594"
import script from "./sendClientWhats.vue?vue&type=script&lang=js"
export * from "./sendClientWhats.vue?vue&type=script&lang=js"
import style0 from "./sendClientWhats.vue?vue&type=style&index=0&id=ffbc4594&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports